import React from "react";
import PropTypes from "prop-types";

const marginBottom = {
  marginBottom: "5px"
};

const ListCustomForms = ({ forms }) => (
  <span>
    {forms.map(form => (
      <a
        key={form.id}
        className="btn btn-indigo btn-raised btn-lg btn-block dashboard-btn pointer-hand"
        style={marginBottom}
        href={`/completed_forms/new?custom_form_id=${form.id}`}
      >
        {form.title}
        ({
          form.all_locations ?
            "All Locations"
          :
            form.locations.map(location => location.name).join(", ")
        })
      </a>
    ))}
  </span>
);

ListCustomForms.propTypes = {
  forms: PropTypes.array.isRequired
};

export default ListCustomForms;
